webpackJsonp([3],{

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(99);






var index = function index(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(551)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

function path(path, name, requireAuth, trade) {
  var other = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var children = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var redirect = arguments[6];

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
    path: '/' + path,
    name: path,
    redirect: redirect,
    meta: {
      requireAuth: requireAuth,
      trade: trade
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(552)("./" + name)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    children: children,
    props: func
  }, other);
}

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */].prototype.xHistory = [];

function func(_ref) {
  var sendDatas = _ref.sendDatas,
      query = _ref.query;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sendDatas, query);
}

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'index',
    component: index
  }, path('login', 'login/login'), path('userNameLogin', 'login/userNameLogin'), path('register1', 'login/register1'), path('register2', 'login/register2'), path('findPassword', 'login/findPassword'), path('announceDetail', 'index/announceDetail', true), path('announcement', 'index/announcement', true), path('anounceList', 'index/anounceList'), path('anounceDetail', 'index/anounceDetail', true), path('recommendation', 'index/recommendation'), path('infoDetail', 'index/infoDetail'), path('originalDetail', 'index/originalDetail', true), path('contactUs', 'index/contactUs'), path('rule', 'index/rule'), path('safe', 'index/safe'), path('about', 'index/about'), path('optional', 'optional/optional', true), path('emitOptional', 'optional/emitOptional', true), path('search', 'optional/search'), path('industyFund', 'optional/industyFund', true), path('conceptFund', 'optional/conceptFund', true), path('individual', 'optional/individual', true), path('industry', 'optional/industry', true), path('performer', 'optional/performer', true), path('DropList', 'optional/DropList', true), path('turnoverList', 'optional/turnoverList', true), path('fivePerformer', 'optional/fivePerformer', true), path('fiveDropList', 'optional/fiveDropList', true), path('volumeList', 'optional/volumeList', true), path('deal/:id/:step', 'deal/deal', true), path('trade/:id/:step', 'deal/trade', true), path('sellDetail', 'deal/sellDetail', true), path('settleDetail', 'deal/settleDetail', true), path('cheekAgreement', 'deal/cheekAgreement', true), path('buy', 'deal/buy', true), path('simpleLine', 'deal/simpleLine', true), path('researchReportDetail', 'deal/researchReportDetail', true), path('stockNoticeDetail', 'deal/stockNoticeDetail', true), path('matchseccess', 'deal/matchseccess', true), path('find', 'find/find', true), path('allBuy', 'find/allBuy', true), path('activeCenter', 'find/activeCenter', true), path('masterList', 'find/masterList', true), path('mySubscribe', 'find/mySubscribe', true), path('subscribeDetails', 'find/subscribeDetails', true), path('winnersList', 'find/winnersList', true), path('winnersDetails', 'find/winnersDetails', true), path('my', 'my/my', true), path('agreement', 'my/agreement', true), path('detailed', 'my/detailed', true), path('invite', 'my/invite', true), path('strategy', 'my/strategy', true), path('agreementDetaile', 'my/agreementDetaile', true), path('myIntegral', 'my/myIntegral', true), path('exchange', 'my/exchange', true), path('task', 'my/task'), path('coupon', 'my/coupon', true), path('historyCoupon', 'my/historyCoupon', true), path('myrule', 'my/rule', true), path('myMessage', 'my/myMessage', true), path('setUp', 'my/setUp', true), path('changePhone', 'my/changePhone', true), path('authentication', 'my/authentication', true), path('myBank', 'my/myBank', true), path('addCard', 'my/addCard', true), path('modifyPassword', 'my/modifyPassword', true), path('presentationPassword', 'my/presentationPassword', true), path('retrievePassword', 'my/retrievePassword', true), path('toRecharge', 'my/toRecharge', true), path('quickpay', 'my/quickpay', true), path('quickpayNext', 'my/quickpayNext', true), path('alipay', 'my/alipay', true), path('alipayDetail', 'my/alipayDetail', true), path('cashWithdrawal', 'my/cashWithdrawal', true), path('selectCard', 'my/selectCard', true), path('personal', 'my/personal', true), path('updateName', 'my/updateName', true), path('setpassword', 'my/setpassword', true), path('beginners', 'my/beginners'), path('beginnersDetail', 'my/beginnersDetail', true), path('myAlipay', 'my/myAlipay', true), path('bankWithdrawal', 'my/bankWithdrawal', true), path('bankDetail', 'my/bankDetail', true), path('transact', 'etf/deal/transact', true), path('transactionDetails', 'etf/deal/transactionDetails', true), path('etfselfOptional', 'etf/optional/etfSelfOptional', true), path('etfsearch', 'etf/optional/etfSearch', true), path('etfEmitOptional', 'etf/optional/etfEmitOptional', true), path('etfQuotation', 'etf/deal/etfQuotation', true), path('assets', 'etf/deal/assets', true), path('subscription', 'etf/deal/subscription', true), path('transaction/:id/:step', 'etf/deal/transaction', true), path('etfbuy', 'etf/deal/etfbuy', true), path('etfMonibuy', 'etf/deal/etfMonibuy', true), path('dangerous', 'etf/deal/dangerous', true), path('cancelOrder', 'etf/deal/cancelOrder', true), path('seach', 'etf/optional/seach', true), path('risk', 'index/risk', true), path('riskStart', 'index/riskDetail', true), path('results', 'index/results', true), path('kcQuotation', 'kc/kcQuotation', true)]
});

router.beforeEach(function (to, from, next) {
  clearInterval(window._getOptional);
  clearInterval(window.currentTime);
  var TOKEN = window.localStorage.getItem('uuid') || '';
  if (to.meta.requireAuth) {
    if (TOKEN) {
      next();
    } else {
      next({
        path: '/login',
        query: { redirect: to.path }
      });
    }
  } else {
    next();
  }
});
router.afterEach(function (to, from) {
  if (to.path == from.path) {
    router.transitionName = '';
  } else {
    if (router.xHistory.length >= 3) {
      router.xHistory.shift();
      router.xHistory.shift();
    }
    router.xHistory.push(to.path);
    if (router.xHistory[0] == router.xHistory[2]) {
      router.transitionName = 'route-back';
    } else {
      router.transitionName = 'route-forward';
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 192:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 194:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 195:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 196:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(502)

var Component = __webpack_require__(199)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(508),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {};
  },

  components: {},
  methods: {},
  mounted: function mounted() {}
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flex_css__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flex_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_flex_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__less_common_css__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__less_common_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__less_common_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__less_mint_ui_css__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__less_mint_ui_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__less_mint_ui_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_index__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_swiper__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_font_font_css__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_font_font_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_font_font_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_echarts__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_echarts__);












__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_mint_ui___default.a);




__WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$echarts = __WEBPACK_IMPORTED_MODULE_13_echarts___default.a;
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_6_axios___default.a;
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.getConfigJson = function () {
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get("serverconfig.json").then(function (result) {
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.ApiUrl = result.ApiUrl;
    }).catch(function (error) {
        console.log(error);
    });
};

var vm = new __WEBPACK_IMPORTED_MODULE_5_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_9__store_index__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_7__App___default.a }

});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    saveToken: function saveToken(_ref, payload) {
        var commit = _ref.commit;

        commit('saveToken', payload);
    }
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  saveToken: function saveToken(state, payload) {
    window.localStorage.setItem('token', payload);
    state.token = payload;
  },
  buy_px: function buy_px(state, payload) {
    state.buy_px = payload;
  },
  realTime: function realTime(state, payload) {
    state.realTime = payload;
  },
  tick: function tick(state, payload) {
    state.tick = payload;
  },
  upList: function upList(state, payload) {
    state.upList = payload;
  },
  downList: function downList(state, payload) {
    state.downList = payload;
  },
  turnoverList: function turnoverList(state, payload) {
    state.turnoverList = payload;
  },
  businessList: function businessList(state, payload) {
    state.businessList = payload;
  },
  szList: function szList(state, payload) {
    state.szList = payload;
  },
  riseList: function riseList(state, payload) {
    state.riseList = payload;
  },
  fivedownList: function fivedownList(state, payload) {
    state.fivedownList = payload;
  },
  industry: function industry(state, payload) {
    state.industry = payload;
  }
});

/***/ }),

/***/ 502:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(243);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  token: '',
  commonkey: "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC29pfMx8vWSgKxvn09P9S1W2k1lOMoID2hMMY+t8gtT5m5fC0Gi1D7Il64Jw294UCUFmaCB9X11qIWRf9DpxOR8iSxq1KCGwvrRHAjHcllp7Pfny/5hpMEEzEvlKzXu3ZAoITMOsle/ZUWJTdplG9XOJY1ukhpmr5ulhm/p11UhwIDAQAB",
  buy_px: [],
  realTime: {},
  tick: [],
  szList: [],
  industry: [],
  lastPrice: '',
  buyNumber: "",
  amount_er: "" };

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
}));

/***/ })

},[242]);


// WEBPACK FOOTER //
// static/js/app.77ce33da69ef1dc0a599.js